import React, { useState } from "react";

import { Grid } from "@mui/material";

import { TextField } from "@aclymatepackages/atoms";
import { editObjectData } from "@aclymatepackages/array-immutability-helpers";
import { convertVolumeUnitsToTons } from "@aclymatepackages/converters";

import UnitsSelect from "../UnitsSelect";

import {
  buildInitialTransactionInputValueFromSchema,
  isEmissionsInputSchemaEnabled,
} from "../../../helpers/components/inputs";

const SteamInput = ({ steamQuantity, steamUnit, editSteamData, disabled }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={7}>
        <TextField
          label="Quantity"
          value={steamQuantity}
          setValue={editSteamData("steamQuantity")}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={5}>
        <UnitsSelect value={steamUnit} setValue={editSteamData("steamUnit")} disabled={disabled} />
      </Grid>
    </Grid>
  );
};

const useSteamInput = ({ transaction, onSave }) => {
  const { status } = transaction;
  const inputSchema = [
    { field: "steamUnit", defaultValue: "lbs" },
    { field: "steamQuantity" },
  ];

  const initialTransactionInputValue =
    buildInitialTransactionInputValueFromSchema(transaction, inputSchema);

  const [steamData, setSteamData] = useState(initialTransactionInputValue);

  const { steamQuantity, steamUnit } = steamData || {};

  const editSteamData = (field) => (value) =>
    editObjectData(setSteamData, field, value);

  const calcSteamTonsCo2e = () => {
    if (!steamQuantity) {
      return 0;
    }

    const TONS_CO2E_PER_TON_STEAM = 0.01;

    return (
      convertVolumeUnitsToTons(steamQuantity, steamUnit) *
      TONS_CO2E_PER_TON_STEAM
    );
  };

  const tonsCo2e = calcSteamTonsCo2e();

  const saveEnabled = isEmissionsInputSchemaEnabled(steamData, inputSchema);

  const onTransactionSave = () =>
    onSave({
      tonsCo2e,
      emissionData: steamData,
    });

  return {
    inputBlock: <SteamInput editSteamData={editSteamData} {...steamData} disabled={status === "locked"} />,
    saveEnabled,
    onTransactionSave,
    tonsCo2e,
  };
};
export default useSteamInput;
